/**
 * This module contains commonly use enums
 */

/**
 * Represents somethings visibility.
 *
 * Either hidden or visible
 */
enum Visibility {
    Hidden,
    Visible,
}

/**
 * Represents a consent decision.
 *
 * Either accepted or declined
 */
enum Consent {
    Accepted,
    Declined,
    Undecided,
}

export { Visibility, Consent }
